module.exports = __webpack_public_path__ + "static/media/upload.fdce146a.svg";